export function validationOk() {
    return { valid: true };
}
export function validationFailure(reason, opts) {
    const why = { reason };
    if ((opts === null || opts === void 0 ? void 0 : opts.objectHash) !== undefined)
        why.objectHash = opts.objectHash;
    if ((opts === null || opts === void 0 ? void 0 : opts.parent) !== undefined)
        why.parent = opts.parent;
    return { valid: false, why };
}
export function wrapValidationFailure(reason, result, objectHash) {
    if (result.valid)
        return result;
    return validationFailure(reason, { objectHash, parent: result.why });
}
export function formatValidationFailure(why) {
    const parts = [];
    let current = why;
    while (current !== undefined) {
        parts.push(current.objectHash === undefined
            ? current.reason
            : `${current.reason} (object ${current.objectHash})`);
        current = current.parent;
    }
    return parts.join(": ");
}
export class ValidationRejectedError extends Error {
    constructor(message, why) {
        super(message);
        this.name = "ValidationRejectedError";
        this.why = why;
    }
}
